import React, { useEffect, useState } from 'react';
import {
    Button,
    Box,
    Typography,
    Paper,
    styled,
    LinearProgress,
    IconButton,
    Divider,
    InputAdornment,
    Tooltip,
    Select,
    InputLabel,
    FormControl,
    MenuItem,
    Snackbar,
    Alert,
    Backdrop,
    CircularProgress,
} from '@mui/material';
import { Close, CloudUpload, Save, RestartAlt, Route, PhotoCamera, Image as ImageIcon } from "@mui/icons-material";
import { AdminPage, SectionTitle, GREEN, LIGHT, BORDER, primaryButtonSx, subCardSx } from '../admin/AdminPageLayout';
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import { travel_admin, update_img_route_banner, upload_image_all } from '../api/API';

// ✅ ซ่อน input file
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

function MainEditimageBanner() {
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    const uid = decoded?.uid || decoded?.user_id || null;

    const [travelRoute, setTravelRoute] = useState([]);
    const [idTravelRouteImg, setIDTravelRouteImg] = useState("");
    const [images, setImages] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const [progress, setProgress] = useState(0);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // "success" | "error" | "warning" | "info"

    const [errorSnackbar, setErrorSnackbar] = useState({
        open: false,
        message: "",
    });

    // ✅ โหลดเส้นทางทั้งหมด
    useEffect(() => {
        const fetchTravelRoute = async () => {
            if (!token) return;
            setInitialLoading(true);
            try {
                const res = await axios.get(travel_admin, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setTravelRoute(res.data || []);

            } catch (error) {
                console.error("โหลดเส้นทางล้มเหลว:", error);
                alert("❌ โหลดข้อมูลเส้นทางล้มเหลว");
            } finally {
                setInitialLoading(false);
            }
        };
        fetchTravelRoute();
    }, [token]);


    // ✅ เมื่อเปลี่ยนเส้นทาง
    const handleTravelChangeImg = (e) => {
        setIDTravelRouteImg(e.target.value);
    };

    const handleImageUpload = (e, type) => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            const newImages = files.map((file) => ({
                type,
                file,
                name: file.name,
                preview: URL.createObjectURL(file),
            }));

            const otherImages = images.filter((img) => img.type !== type);
            setImages([...otherImages, ...newImages]);
        }
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };


    const handleRemoveImage = (type, indexToRemove) => {
        // ลบเฉพาะภาพในกลุ่ม type นั้น ๆ
        const updatedImages = images?.filter((img, index) => {
            if (img.type !== type) return true; // เก็บไว้ถ้าคนละ type
            // ถ้า type เดียวกัน ให้ลบเฉพาะตัวที่ตรง index ของกลุ่มนั้น
            const sameTypeImages = images?.filter((i) => i.type === type);
            const targetImage = sameTypeImages[indexToRemove];
            return img !== targetImage;
        });

        setImages(updatedImages);
    };

    // ✅ ฟังก์ชันอัปโหลด
    const handleSubmit = async () => {
        if (!idTravelRouteImg) {
            alert("กรุณาเลือกเส้นทางก่อนอัปโหลด");
            return;
        }

        try {
            setUploading(true);
            setProgress(0);

            const newRouteId = idTravelRouteImg;
            const types = [...new Set(images.map((img) => img.type))];
            const uploadedPaths = [];

            // 🌀 วนแต่ละ type แล้วอัปโหลด
            for (const type of types) {
                const imagesOfType = images.filter((img) => img.type === type);
                if (imagesOfType.length === 0) continue;

                const formDataUpload = new FormData();
                imagesOfType.forEach((img) => {
                    formDataUpload.append("files", img.file);
                });

                formDataUpload.append("media_type", "image");
                formDataUpload.append("type", type);
                formDataUpload.append("place_type", "route");
                formDataUpload.append("ref_id", newRouteId);
                formDataUpload.append("ref_name", "route");

                const uploadRes = await axios.post(upload_image_all, formDataUpload, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                });

                console.log("📦 uploadRes.data:", uploadRes.data);

                // ✅ รองรับทั้งแบบ data.data.results และ data.results
                const results = uploadRes.data?.data?.results || uploadRes.data?.results || [];
                const paths = results.map((r) => r.file_path);

                if (paths.length > 0) {
                    uploadedPaths.push(...paths);
                } else {
                    console.warn(`⚠️ การอัปโหลด ${type} สำเร็จแต่ไม่ได้รับ path กลับมา`);
                }
            }
            // console.log("uploadedPaths0]", uploadedPaths);

            // ✅ ตรวจว่ามีไฟล์ที่อัปโหลดสำเร็จหรือไม่
            if (uploadedPaths.length === 0) {
                throw new Error("ไม่มีไฟล์ถูกอัปโหลดสำเร็จ");
            }

            // ✅ ดึง path ล่าสุดอย่างปลอดภัย
            const finalPath = uploadedPaths[uploadedPaths.length - 1] || "";

            // ✅ เช็กว่ามี /uploads/ จริงไหม
            const index = finalPath.indexOf("/uploads/");
            const pathFromUploads = index !== -1 ? finalPath.substring(index + 1) : finalPath;

            const placePayload = {
                tid: parseInt(newRouteId),
                path: pathFromUploads,
            };

            console.log("🟢 placePayload", placePayload);

            const placeRes = await axios.post(update_img_route_banner, placePayload, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            console.log("🟢 placeRes:", placeRes);

            if (placeRes.status === 200 || placeRes.status === 201) {
                setSnackbarMessage("✅ ข้อมูลและรูปภาพถูกบันทึกเรียบร้อยแล้ว!");
                setSnackbarSeverity("success"); // ✅ สีเขียว
                setSnackbarOpen(true);
                setImages([]);
            } else {
                setSnackbarMessage(`❌ บันทึกข้อมูลไม่สำเร็จ (Status: ${placeRes.status})`);
                setSnackbarSeverity("error");
                setSnackbarOpen(true);
            }
        } catch (error) {
            console.error("❌ Upload error:", error);
            setSnackbarMessage(`❌ อัปโหลดล้มเหลว: ${error.message}`);
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        } finally {
            setUploading(false);
            setProgress(0);
        }
    };

    return (
        <>
            <AdminPage
                icon={<PhotoCamera />}
                title="แก้ไขรูปภาพแบนเนอร์เส้นทาง"
                subtitle="เลือกเส้นทาง แล้วอัปโหลดรูปภาพแบนเนอร์ใหม่เพื่อแทนที่รูปเดิม"
                maxWidth={760}
                actions={
                    <>
                        <Button
                            variant="outlined"
                            color="inherit"
                            startIcon={<RestartAlt />}
                            onClick={handleRemoveImage}
                            sx={{ borderRadius: 3, width: { xs: '100%', sm: 'auto' } }}
                            disabled={uploading}
                        >
                            ยกเลิก
                        </Button>
                        <Button
                            variant="contained"
                            size="large"
                            startIcon={<Save />}
                            onClick={handleSubmit}
                            sx={primaryButtonSx}
                            disabled={uploading}
                        >
                            {uploading ? 'กำลังบันทึก...' : 'บันทึก'}
                        </Button>
                    </>
                }
            >
                {/* ① Select เส้นทาง */}
                <SectionTitle step={1} title="เลือกเส้นทาง" />
                <FormControl fullWidth disabled={uploading}>
                    <InputLabel id="travel-route-select-img-label">เลือกเส้นทาง</InputLabel>
                    <Select
                        labelId="travel-route-select-img-label"
                        id="travel-route-select-img"
                        value={idTravelRouteImg}
                        label="เลือกเส้นทาง"
                        onChange={handleTravelChangeImg}
                        color="primary"
                        sx={{ borderRadius: 3 }}
                        startAdornment={
                            <InputAdornment position="start">
                                <Route sx={{ color: GREEN }} />
                            </InputAdornment>
                        }
                    >
                        {travelRoute?.map((route) => (
                            <MenuItem key={route.tid} value={route.tid}>
                                {route.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Divider sx={{ my: 3 }} />

                {/* ② อัปโหลดรูป */}
                <SectionTitle step={2} title="อัปโหลดรูปภาพแบนเนอร์เส้นทาง" />
                <Box
                    sx={{
                        border: `2px dashed ${BORDER}`,
                        borderRadius: 3,
                        bgcolor: LIGHT,
                        p: 3,
                        textAlign: 'center',
                    }}
                >
                    <CloudUpload sx={{ fontSize: 48, color: GREEN }} />
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        เลือกไฟล์รูปภาพแบนเนอร์ (เลือกได้หลายไฟล์)
                    </Typography>
                    <Button
                        variant="outlined"
                        component="label"
                        startIcon={<CloudUpload />}
                        sx={{ borderRadius: 3, color: GREEN, borderColor: GREEN, bgcolor: 'white' }}
                    >
                        เลือกรูปแบรนเนอร์เส้นทาง
                        <input
                            type="file"
                            accept="image/*"
                            multiple
                            hidden
                            onChange={(e) => handleImageUpload(e, "banner_route")}
                        />
                    </Button>
                </Box>

                {/* ตัวอย่างรูปที่เลือก */}
                {images.filter((img) => img.type === "banner_route").length > 0 ? (
                    <Box
                        sx={{
                            mt: 2,
                            display: 'grid',
                            gap: 2,
                            gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
                        }}
                    >
                        {images
                            .filter((img) => img.type === "banner_route")
                            .map((img, index) => (
                                <Paper key={index} variant="outlined" sx={{ ...subCardSx, p: 1, position: 'relative' }}>
                                    <img
                                        src={img.preview}
                                        alt={`preview-${index}`}
                                        style={{ width: "100%", height: 150, objectFit: "cover", borderRadius: 8, display: 'block' }}
                                    />
                                    <Tooltip title="ลบรูปนี้">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleRemoveImage(img.type, index)} // ✅ ส่ง type ด้วย
                                            sx={{
                                                position: 'absolute',
                                                top: 12,
                                                right: 12,
                                                bgcolor: 'rgba(255,255,255,0.9)',
                                                color: 'error.main',
                                                '&:hover': { bgcolor: 'white' },
                                            }}
                                        >
                                            <Close fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Typography variant="body2" noWrap sx={{ mt: 1, px: 0.5 }} title={img.name}>
                                        {img.name}
                                    </Typography>
                                </Paper>
                            ))}
                    </Box>
                ) : (
                    <Box sx={{ mt: 2, py: 3, textAlign: 'center', color: 'text.disabled' }}>
                        <ImageIcon sx={{ fontSize: 40 }} />
                        <Typography variant="body2">ยังไม่ได้เลือกรูปภาพ</Typography>
                    </Box>
                )}

                {/* Progress Bar */}
                {uploading && (
                    <Box sx={{ width: '100%', mt: 2 }}>
                        <LinearProgress variant="determinate" value={progress} color="primary" sx={{ height: 8, borderRadius: 4 }} />
                        <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
                            กำลังอัปโหลด... {Math.round(progress)}%
                        </Typography>
                    </Box>
                )}
            </AdminPage>

            <Snackbar
                open={errorSnackbar.open}
                autoHideDuration={3000}
                onClose={() => setErrorSnackbar({ open: false, message: "" })}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    severity="error"
                    variant="filled"
                    sx={{ fontWeight: "bold" }}
                >
                    {errorSnackbar.message}
                </Alert>
            </Snackbar>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                    sx={{ width: "100%" }}
                    variant="filled"
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
            {/* Loading Overlay */}
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={initialLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

export default MainEditimageBanner;
